/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingserviceMelcoModelsError,
    DigitizingserviceMelcoModelsErrorFromJSON,
    DigitizingserviceMelcoModelsErrorToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItemToJSON,
} from '../models';

export interface DigitizingServiceNotificationsApiDigitizeDeleteNotificationRequest {
    id: string;
}

export interface DigitizingServiceNotificationsApiDigitizeGetNotificationListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
}

/**
 * 
 */
export class DigitizingServiceNotificationsApi extends runtime.BaseAPI {

    /**
     */
    async digitizeDeleteAllNotificationsRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/notifications`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async digitizeDeleteAllNotifications(): Promise<void> {
        await this.digitizeDeleteAllNotificationsRaw();
    }

    /**
     */
    async digitizeDeleteNotificationRaw(requestParameters: DigitizingServiceNotificationsApiDigitizeDeleteNotificationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeDeleteNotification.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async digitizeDeleteNotification(requestParameters: DigitizingServiceNotificationsApiDigitizeDeleteNotificationRequest): Promise<void> {
        await this.digitizeDeleteNotificationRaw(requestParameters);
    }

    /**
     */
    async digitizeGetNotificationListRaw(requestParameters: DigitizingServiceNotificationsApiDigitizeGetNotificationListRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizeGetNotificationList(requestParameters: DigitizingServiceNotificationsApiDigitizeGetNotificationListRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsNotificationListItem> {
        const response = await this.digitizeGetNotificationListRaw(requestParameters);
        return await response.value();
    }

}
